import { FeatureType, TerrainType } from "../hex/types.js";
import { z } from "zod";
export const TerrainFilterSchema = z.object({
    terrain_type: z.nativeEnum(TerrainType).nullable().optional().transform(v => v ?? undefined),
    feature_type: z.nativeEnum(FeatureType).nullable().optional().transform(v => v ?? undefined),
    road: z.boolean().nullable().optional().transform(v => v ?? undefined),
    river: z.boolean().nullable().optional().transform(v => v ?? undefined),
});
